// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
let QuotationsVersionModule = class QuotationsVersionModule extends Vue {
    constructor() {
        super(...arguments);
        this.isDragged = false;
        this.isNextVisible = false;
        this.isPrevVisible = false;
    }
    demarkedContent(item) {
        if (!item.content) {
            return '';
        }
        const obj = this.DeMarked.convertMDToObjects(item.content);
        if (!obj) {
            return '';
        }
        const objWithDriver = obj.filter((o) => 'driver' in o);
        return this.DeMarked.convertObjectsToHTML(objWithDriver);
    }
    initScroll() {
        const elem = this.containerRef;
        if (!elem || this.isMobile) {
            return;
        }
        const onPointerMove = (e) => {
            if (elem.hasPointerCapture(e.pointerId)) {
                this.isDragged = true;
                elem.scrollLeft -= e.movementX;
            }
            else {
                elem.setPointerCapture(e.pointerId);
            }
        };
        elem.addEventListener('pointerdown', () => {
            elem.addEventListener('pointermove', onPointerMove);
        });
        elem.addEventListener('pointerup', (e) => {
            if (!this.isDragged) {
                return true;
            }
            this.isDragged = false;
            elem.releasePointerCapture(e.pointerId);
            elem.removeEventListener('pointermove', onPointerMove);
            this.updateArrows();
        });
    }
    goNext() {
        if (!this.containerRef) {
            return;
        }
        this.containerRef.scrollLeft += this.containerRef.clientWidth;
        this.updateArrows();
        setTimeout(this.updateArrows, 500);
    }
    goPrev() {
        if (!this.containerRef) {
            return;
        }
        this.containerRef.scrollLeft -= this.containerRef.clientWidth;
        this.updateArrows();
        setTimeout(this.updateArrows, 500);
    }
    updateArrows() {
        if (!this.containerRef) {
            return;
        }
        this.isNextVisible = this.containerRef.scrollLeft < this.containerRef.scrollWidth - this.containerRef.clientWidth;
        this.isPrevVisible = this.containerRef.scrollLeft > 0;
    }
    onActiveChange() {
        if (this.active) {
            this.updateArrows();
            setTimeout(this.updateArrows, 500);
        }
    }
};
__decorate([
    Prop({ required: true })
], QuotationsVersionModule.prototype, "DeMarked", void 0);
__decorate([
    Prop({ type: Array, required: true })
], QuotationsVersionModule.prototype, "items", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], QuotationsVersionModule.prototype, "active", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], QuotationsVersionModule.prototype, "isMobile", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], QuotationsVersionModule.prototype, "isLazy", void 0);
__decorate([
    Prop({ type: String, required: false, default: '' })
], QuotationsVersionModule.prototype, "fallbackImage", void 0);
__decorate([
    Ref('container')
], QuotationsVersionModule.prototype, "containerRef", void 0);
__decorate([
    Watch('active')
], QuotationsVersionModule.prototype, "onActiveChange", null);
QuotationsVersionModule = __decorate([
    Component({
        name: 'AbstractQuotationsModule',
        mounted() {
            this.initScroll();
            this.updateArrows();
        }
    })
], QuotationsVersionModule);
export { QuotationsVersionModule };
